module.exports = __webpack_public_path__ + "static/mobile_pay-102ad092f964dc06ce16b42b4b049492.svg";